import { storyblokInit, apiPlugin } from "@storyblok/react"
import { components } from "../storyblok.components"
export function initStoryblok() {
  const token = process.env.REACT_APP_STORYBLOK_TOKEN

  if (!token) {
    throw new Error("Missing Storyblok access token")
  }

  storyblokInit({
    accessToken: token,
    use: [apiPlugin],
    components,
  })
}
